import { useEffect, useState } from "react";

const DEFAULT_INTERVAL_MS = 30_000;

export function useNow(
  enabled: boolean,
  intervalMs: number = DEFAULT_INTERVAL_MS,
): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) return;
    queueMicrotask(() => setNow(Date.now()));
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [enabled, intervalMs]);

  return now;
}
